import React, { useState } from "react";

import LandingPage from "../CommonComponent/LandingPage";
import OnboardingForm from "../CommonComponent/OnboardingForm/OnboardingForm";
import SuccessLandingPage from "../CommonComponent/SuccessLandingPage";

import onboardingBg from "../../../../assets/images/onboarding-bg.png";

export default function EnvironmentLandingPage() {
  const [displayForm, setDisplayForm] = useState(false);
  const [success, setSuccess] = useState("");

  if (displayForm) {
    return <OnboardingForm formStep={2} setDisplayForm={setDisplayForm} setSuccess={setSuccess} />;
  }

  if ((success === "Environment") && !displayForm) {
    return (
      <SuccessLandingPage success={success} image={onboardingBg} />
    );
  }

  return (
    <LandingPage
      heading={(
        <>
          Environment Testing journey
          <br />
          with us
        </>
        )}
      description={(
        <>
          Please setup your environment sample
          <br />
          submission fields to enable submitting
          <br />
          environment samples.
        </>
        )}
      image={onboardingBg}
      setDisplayForm={setDisplayForm}
    />
  );
}
